<template>
  <div>

    <Head title="訂單管理" />
    <ScrollTop />

    <Breadcrumb :home="breadcrumb_home" :model="breadcrumb_paths" />

    <order-template>
      <DataTable :value="$page.props.orders.data" :selection.sync="selectedOrders" sortMode="multiple"
        :multiSortMeta.sync="multiSortMeta" @sort="onSort($event)">
        <template #header>
          <div class="flex justify-between items-center">
            <div class="flex flex-row gap-2 items-center" v-if="selectedOrders.length > 0">
              <span> 已選擇 {{ selectedOrders.length }} 個 </span>
              <span>
                <Dropdown :options="batch_action.options" v-model="batch_action.selected" optionLabel="name"
                  optionValue="code" placeholder="變更訂單狀態…" @change="batchAction" />
              </span>
            </div>
            <div v-else></div>
            <div class="flex flex-row items-center gap-2">
              <span class="p-input-icon-left">
                <i class="pi pi-search" />
                <InputText class="w-52" v-model="search" placeholder="搜尋訂單" @input="onSearch" />
              </span>
            </div>
          </div>
        </template>

        <Column headerClass="w-11" selectionMode="multiple"></Column>

        <Column field="created_at" header="時間" sortable>
          <template #body="slotProps">
            {{ formatDate(slotProps.data.created_at) }}
          </template>
        </Column>

        <Column field="order_no" header="訂單編號" sortable></Column>

        <Column header="訂購人" field="purchaser.name" sortable>
          <template #body="slotProps">
            <template v-if="slotProps.data.user_id != 0">{{
              slotProps.data.purchaser.name
            }}</template>
            <template v-else>(訪){{ slotProps.data.purchaser.name }}</template>
          </template>
        </Column>

        <Column header="連絡電話" field="purchaser.phone" sortable>
          <template #body="slotProps">
            {{ slotProps.data.purchaser.phone }}
          </template>
        </Column>
        <Column header="金額" field="total_price" sortable>
          <template #body="slotProps">
            {{ slotProps.data.total_price | commaFormat | priceFormat }}
          </template>
        </Column>
        <Column header="狀態" field="status" sortable>
          <template #body="slotProps">
            {{ statusString(slotProps.data.status) }}
          </template>
        </Column>

        <Column headerClass="w-36" header="動作">
          <template #body="slotProps">
            <template v-if="slotProps.data.status == 1">
              <SplitButton label="確認" :model="splitButonFunction(slotProps.data)" @click="confirmOrder(slotProps.data)">
              </SplitButton>
            </template>
            <template v-else-if="slotProps.data.status == -1">
              <SplitButton label="取消" :model="splitButonFunction(slotProps.data)" @click="confirmCancel(slotProps.data)">
              </SplitButton>
            </template>
            <template v-else-if="slotProps.data.status == -3">
              <SplitButton label="同意" :model="splitButonFunction(slotProps.data)" @click="confirmReturn(slotProps.data)">
              </SplitButton>
            </template>
            <template v-else-if="slotProps.data.status == -4">
              <SplitButton label="完成" :model="splitButonFunction(slotProps.data)" @click="completeReturn(slotProps.data)">
              </SplitButton>
            </template>
            <template v-else>
              <SplitButton label="詳細" :model="splitButonFunction(slotProps.data)" @click="edit(slotProps.data)">
              </SplitButton>
            </template>
          </template>
        </Column>

        <template #empty>沒有任何符合條件的訂單。</template>
      </DataTable>
    </order-template>

    <div class="w-full mt-10 flex justify-around">
      <Paginator :page-data="$page.props.orders" />
    </div>
  </div>
</template>

<script>
import Layout from "../Layout";
import ScrollTop from "primevue/scrolltop";
import Breadcrumb from "@/Shared/Components/Breadcrumb";
import OrderTemplate from "./Shared/OrderTemplate";
import DataTable from "primevue/datatable";
import Dropdown from "primevue/dropdown";
import Column from "primevue/column";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import MultiSelect from "primevue/multiselect";
import SplitButton from "primevue/splitbutton";
import Tag from "primevue/tag";
import Paginator from "@/Shared/Paginator";

export default {
  components: {
    ScrollTop,
    Breadcrumb,
    OrderTemplate,
    DataTable,
    Dropdown,
    Column,
    Button,
    InputText,
    MultiSelect,
    SplitButton,
    Tag,
    Paginator,
  },
  layout: Layout,
  filters: {
    priceFormat: function (value) {
      return "$" + value;
    },
    commaFormat: function (value) {
      return value
        .toString()
        .replace(
          /^(-?\d+?)((?:\d{3})+)(?=\.\d+$|$)/,
          function (all, pre, groupOf3Digital) {
            return pre + groupOf3Digital.replace(/\d{3}/g, ",$&");
          }
        );
    },
  },
  data() {
    return {
      breadcrumb_home: {
        label: "訂單管理",
        disabled: true,
      },
      breadcrumb_paths: [
        {
          label: this.$page.props.breadcrumb_label,
          disabled: true,
        },
      ],
      batch_action: {
        options: [
          {
            code: 0,
            name: "未付款",
          },
          {
            code: 1,
            name: "待確認",
          },
          {
            code: 2,
            name: "已確認",
          },
          {
            code: 3,
            name: "備貨中",
          },
          {
            code: 4,
            name: "準備出貨",
          },
          {
            code: 5,
            name: "已出貨",
          },
          {
            code: 6,
            name: "已完成",
          },
          {
            code: -1,
            name: "申請取消",
          },
          {
            code: -2,
            name: "已取消",
          },
          {
            code: -3,
            name: "申請退款",
          },
          {
            code: -4,
            name: "退款中",
          },
          {
            code: -5,
            name: "已退款",
          },
          {
            code: -6,
            name: "貨態異常",
          },
        ],
        selected: null,
      },
      filterables: [
        {
          label: "上架中",
          condition: {
            field: "available",
            value: 1,
          },
        },
        {
          label: "未上架",
          condition: {
            field: "available",
            value: 0,
          },
        },
      ],
      selectedFilters: [],
      selectedOrders: [],
      multiSortMeta: [],
      search: null,
    };
  },
  methods: {
    statusString(statusCode) {
      switch (statusCode) {
        case 0:
          return "未付款";

        case 1:
          return "待確認";

        case 2:
          return "已確認";

        case 3:
          return "備貨中";

        case 4:
          return "準備出貨";

        case 5:
          return "已出貨";

        case 6:
          return "已完成";

        case -1:
          return "申請取消";

        case -2:
          return "已取消";

        case -3:
          return "申請退款";

        case -4:
          return "退款中";

        case -5:
          return "已退款";

        case -6:
          return "貨態異常";
      }
    },
    formatDate(dateString) {
      let date = new Date(dateString);
      return (
        date.getFullYear() +
        "/" +
        (date.getMonth() + 1).toString().padStart(2, "0") +
        "/" +
        date.getDate().toString().padStart(2, "0") +
        " " +
        date.getHours().toString().padStart(2, "0") +
        ":" +
        date.getMinutes().toString().padStart(2, "0") +
        ":" +
        date.getSeconds().toString().padStart(2, "0")
      );
    },
    getQueryStrings() {
      let queryStr = window.location.search,
        queryArr = queryStr.replace("?", "").split("&"),
        queryParams = [];

      for (let q = 0, qArrLength = queryArr.length; q < qArrLength; q++) {
        let qArr = queryArr[q].split("=");
        queryParams[qArr[0]] = qArr[1];
      }

      return _(queryParams).omitBy(_.isUndefined).omitBy(_.isNull).value();
    },
    splitButonFunction(item) {
      return _.concat(
        {
          label: '檢視詳細資料',
          command: () => this.edit(item)
        },
        {
          separator: true,
        },
        {
          label: '變更訂單狀態',
          items: _.map(this.batch_action.options, (option) => {
            return {
              label: option.name,
              command: () => {
                this.selectedAction(item.id, option.code);
              },
            };
          })
        }
      );
    },
    confirmOrder(item) {
      this.selectedAction(item.id, 2);
    },
    confirmCancel(item) {
      this.selectedAction(item.id, -2);
    },
    confirmReturn(item) {
      this.selectedAction(item.id, -4);
    },
    completeReturn(item) {
      this.selectedAction(item.id, -5);
    },
    selectedAction(id, code) {
      if (code == "edit") {
        this.$inertia.visit(route("admin.orders.edit", id), {
          data: {
            from: btoa(encodeURIComponent(this.$page.url)),
          },
        });
        return;
      }

      this.$inertia.post(
        route("admin.orders.batch_set_status"),
        {
          id: [id],
          code: code,
          from: this.$page.url,
        },
        {
          preserveState: true,
          preserveScroll: true,
        }
      );
    },
    batchAction() {
      let code = this.batch_action.selected;
      this.batch_action.selected = null;

      let batch = this.selectedOrders.map((selected) => selected.id);

      this.selectedOrders = [];

      this.$inertia.post(
        route("admin.orders.batch_set_status"),
        {
          id: batch,
          code: code,
          from: this.$page.url,
        },
        {
          preserveState: true,
          preserveScroll: true,
        }
      );
    },
    edit(item, back_url = this.$page.url) {
      this.$inertia.visit(route("admin.orders.edit", item.id), {
        data: {
          from: btoa(encodeURIComponent(back_url)),
        },
      });
    },
    onSearch: _.debounce(function () {
      this.selectedOrders = [];

      let queryStringArray = this.getQueryStrings();

      queryStringArray["search"] = this.search;

      let queryStrings = [];

      _.forIn(queryStringArray, (value, key) => {
        queryStrings.push(key + "=" + value);
      });

      let url = this.$page.url.split("?")[0] + "?" + queryStrings.join("&");

      this.$inertia.visit(url, {
        preserveScroll: true,
        preserveState: true,
        only: ["orders", "counts"],
      });
    }, 1000),
    onSort(event) {
      this.selectedOrders = [];

      let queryStringArray = this.getQueryStrings();

      queryStringArray["sort"] = JSON.stringify(event.multiSortMeta);

      let queryStrings = [];

      _.forIn(queryStringArray, (value, key) => {
        queryStrings.push(key + "=" + value);
      });

      let url = this.$page.url.split("?")[0] + "?" + queryStrings.join("&");

      this.$inertia.visit(url, {
        preserveScroll: true,
        preserveState: true,
        only: ["merchandises"],
      });
    },
    onFilter(event) {
      this.selectedOrders = [];

      let queryStringArray = this.getQueryStrings();

      queryStringArray["filter"] = JSON.stringify(event.value);

      let queryStrings = [];

      _.forIn(queryStringArray, (value, key) => {
        queryStrings.push(key + "=" + value);
      });

      let url = this.$page.url.split("?")[0] + "?" + queryStrings.join("&");

      this.$inertia.visit(url, {
        preserveScroll: true,
        preserveState: true,
        only: ["merchandises"],
      });
    },
  },
  mounted() {
    if (this.getQueryStrings()["sort"]) {
      this.multiSortMeta = JSON.parse(
        decodeURI(this.getQueryStrings()["sort"])
      );
    }

    if (this.getQueryStrings()["search"]) {
      this.search = decodeURI(this.getQueryStrings()["search"]);
    }

    if (this.getQueryStrings()["filter"]) {
      let selected = JSON.parse(decodeURI(this.getQueryStrings()["filter"]));

      _.forIn(this.filterables, (item) => {
        let found = _.find(selected, item.condition);
        if (found) {
          this.selectedFilters.push(found);
        }
      });
    }
  },
};
</script>

<style lang="postcss">
.p-breadcrumb {
  @apply border-0;
}
</style>